import { useMutation } from "@tanstack/react-query";

const useSingleDownloadPDF = (downloadFn) => {
  const onSuccessDownloadPDF = (response, variables) => {
    if (!response || !response.headers) {
      throw new Error("No response or headers found");
    }
    const contentType = response.headers["content-type"];
    if (contentType !== "application/pdf") {
      throw new Error("Received non-PDF content");
    }

    const blob = new Blob([response.data], { type: "application/pdf" });
    const url = window.URL.createObjectURL(blob);

    let fileName = variables?.fileName || "resultentrypdf.pdf";

    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const { mutate, isLoading } = useMutation(downloadFn, {
    onSuccess: (response, variables) => onSuccessDownloadPDF(response, variables),
    onError: (error) => {
      console.error("Error downloading the file:", error);
      console.error("Error message:", error.message);

      if (error.originalError) {
        console.error("Original error:", error.originalError);
      }

      if (error.parseError) {
        console.error("JSON parse error:", error.parseError);
      }

      if (error.blobError) {
        console.error("Blob reading error:", error.blobError);
      }
    },
  });

  return { mutate, isLoading };
};

export default useSingleDownloadPDF;
